module.exports = __webpack_public_path__ + "img/search-normal.2f90c1f8.svg";